import React, { useState,useEffect} from 'react';
import { Button } from 'react-bootstrap';
import AttendanceDatatable from './AttendanceDatatable';
import AttendanceModal from './AttendanceModal';



const AttendanceListTab = (props) => {

    
    const [show , setShow]= useState( false );
    const [recordId, setRecordId ] = useState();    
    const [checkTime, setCheckTime] = useState(null);

    const handleCallback = (id) => {      
      if(id!==''){
        props.parentCallback(id,'DETAIL');
      }else{
        modalCallback(true,id);
      }
    };
 
    const modalCallback = (show,id) => {             
        setRecordId(id);  
        setShow(show);           
    }

    useEffect(() => {      
      setCheckTime(Date.now());
    }, [props.isActive])

  
    return (
        <div className={`tab-pane ${props.isActive ? 'active' : ''}`}>          
        
          <AttendanceDatatable            
            parentCallback={handleCallback}    
            modalShow={show}    
            checkTime={checkTime}                            
          />
         
          <AttendanceModal 
            modal={show}
            parentCallback={modalCallback}
            selectedRecord={recordId}                      
          />
         
          <Button
            bsStyle="primary"
          //  bsSize="large"
            className="ml-3 mt-3"
            onClick={() => handleCallback('')} 
          >
            <i class="fas fa-plus"></i>
          </Button>
        </div>
    );
};

export default AttendanceListTab;